import { Component, OnInit } from '@angular/core'
import { AngularFirestore } from '@angular/fire/firestore'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { ReplaySubject } from 'rxjs'
import { take, takeUntil } from 'rxjs/operators'
import { AppState } from 'src/app/store/state'
import * as fromUser from '../../store/user'
import { nullUser } from '../../store/user'


@Component({
  selector: 'app-front',
  templateUrl: './front.page.html',
  styleUrls: ['./front.page.scss'],
})
export class FrontPage implements OnInit {

  slides = [
    {
      figure: '/assets/ua/img/mockups/mockup5.png',
      title: '1. Descarga la aplicación',
    },
    {
      figure: '/assets/ua/img/mockups/mockup5.png',
      title: '2. Crea una cuenta en la aplicación',
      description: 'Tendrás acceso a contenido seleccionicado durante 15 días'
    },
    {
      figure: '/assets/ua/img/mockups/mockup5.png',
      figure2: '/assets/ua/img/mockups/mockup5.png',
      title: '3. Aprende',
      description: 'Estudia las lecciones y haz los ejercicios correspondientes'
    },
    {
      figure: '/assets/ua/img/mockups/mockup5.png',
      title: '4. Compra una subscripción en nuestra página',
      description: 'Tendrás acceso a todo el contenido hasta el vencimiento de la subscripción'
    },
  ]

  offers: any = {}
  selectedOffer: string = "center"
  purchase: any = {}

  loggedIn: boolean

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private afs: AngularFirestore) {
    this.store.select('user').
      pipe(takeUntil(this.destroyed$)).
      subscribe(
      user => {
        this.loggedIn = user != nullUser
      })
  }

  select(selectedOffer: string){
    this.selectedOffer = selectedOffer
  }

  signIn() {
    this.store.dispatch(fromUser.actions.signIn({ referrer: '/front' }))
  }

  logOut() {
    this.store.dispatch(fromUser.actions.logOut())
  }

  ngOnInit() {
    this.afs.collection('subscriptions').doc('pricing').collection('display').valueChanges().pipe(take(1)).subscribe(data => {
      for (let display of data){
        this.afs.collection('subscriptions').doc('pricing').collection('offers').doc(display['name']).valueChanges().pipe(take(1)).subscribe(offer => {
          if (display['index'] == 0){
            this.offers['left'] = offer
          } else if (display['index'] == 1){
            this.offers['center'] = offer
          } else if (display['index'] == 2) {
            this.offers['right'] = offer
          }
        })
      }
    })
  }

  navigate(target: string) {
    this.router.navigate([target])
  }

}
